import BulletListInfo from "@/components/BulletListInfo";
import useTranslations from "@/i18n/useTranslations";

interface Props {
  sideRailBulletList?: {
    title?: string;
    items?: { heading: string; description: string }[];
    theme?: "light" | "dark";
  };
}

const BulletListInfoSidebar = ({ sideRailBulletList }: Props) => {
  const t = useTranslations("Common");
  const isLightTheme = sideRailBulletList?.theme === "light";
  const title = sideRailBulletList?.title;
  const monarchItems = sideRailBulletList?.items;
  const localizedDefaults = [
    {
      heading: t("bundleAndSaveHeading"),
      description: t("bundleAndSaveDesc"),
    },
    {
      heading: t("careerBoostHeading"),
      description: t("careerBoostDesc"),
    },
  ];
  const detailItems =
    monarchItems !== undefined && monarchItems?.length > 0
      ? monarchItems
      : localizedDefaults;

  const resolvedTitle =
    !title ||
    title === "Invest in your carrer" ||
    title === "Invest in your career"
      ? t("investInYourCareer")
      : title;

  return (
    <div
      className={`p-3 rounded-xl ${isLightTheme ? "bg-white" : "bg-[#00262B]"}`}
    >
      <BulletListInfo
        title={resolvedTitle}
        details={detailItems}
        titleFontClass={`!text-2xl ${isLightTheme && "!text-primary"}`}
        descriptionFontClass={`!text-sm ${isLightTheme && "text-primary"}`}
        containerClass="!gap-4"
        iconColor={isLightTheme ? "#00262B" : "white"}
      />
    </div>
  );
};

export default BulletListInfoSidebar;
